import { BIRTH_INDEX_COLLECTIONS } from './birthIndexCollections';
import { DEATH_INDEX_COLLECTIONS } from './deathIndexCollections';
import { IMMIGRANTS_INDEX_COLLECTIONS } from './immigrantsIndexCollections';
import { MARRIAGE_INDEX_COLLECTIONS } from './marriageIndexCollections';
import { MILITARY_INDEX_COLLECTIONS } from './militaryIndexCollections';
import { SOCIAL_SECURITY_INDEX_COLLECTIONS } from './socialSecurityIndexCollections';

export const DATA_COLLECTIONS = [
  ...BIRTH_INDEX_COLLECTIONS,
  ...DEATH_INDEX_COLLECTIONS,
  ...MARRIAGE_INDEX_COLLECTIONS,
  ...MILITARY_INDEX_COLLECTIONS,
  ...IMMIGRANTS_INDEX_COLLECTIONS,
  ...SOCIAL_SECURITY_INDEX_COLLECTIONS,
];
